document.addEventListener("DOMContentLoaded", function () {
  //product slider
const productSlider = new Swiper(".product-slider", {
  speed: 700,
  spaceBetween: 20,
  navigation: {
    nextEl: ".product-slider .swiper-button-next",
    prevEl: ".product-slider .swiper-button-prev",
  },
  pagination: {
    el: ".product-slider .swiper-pagination",
    clickable: true,
  },
  on: {
    init: function () {
      handleVideoPlayback(this);
    },
    slideChangeTransitionEnd: function () {
      handleVideoPlayback(this);
    },
  },
});


function handleVideoPlayback(swiper) {
  const slides = swiper.slides;
  slides.forEach((slide, index) => {
    const video = slide.querySelector("video.product-video");
    if (video) {
      if (index === swiper.activeIndex) {
        video.currentTime = 0;
        video.play().catch((err) => console.warn("Autoplay error:", err));
      } else {
        video.pause();
        video.currentTime = 0;
      }
    }
  });
}


  //change product image on variants click + change active variant in btn + tabs

  const variantRadios = document.querySelectorAll(
    '.product__info-middle input[type="radio"]'
  );

  const addToCartButton = document.querySelector('button[id^="AddToCart"]');

  variantRadios.forEach((radio) => {
    radio.addEventListener("change", function () {
      const selectedValue = this.value;
      const variantId = this.dataset.variantId;
      const price = this.dataset.price;
      const discountPrice = this.dataset.discountPrice;

      const rechargeOneTimePrice = document.getElementById(
        "recharge-one-time-price"
      );
      const rechargeOriginalPrice = document.getElementById(
        "recharge-original-price"
      );
      const rechargeDiscountPrice = document.getElementById(
        "recharge-discount-price"
      );

      if (price && rechargeOneTimePrice) {
        rechargeOneTimePrice.textContent = formatMoney(price);
      }

      if (price && rechargeOriginalPrice) {
        rechargeOriginalPrice.textContent = formatMoney(price);
      }

      if (discountPrice && rechargeDiscountPrice) {
        rechargeDiscountPrice.textContent = formatMoney(discountPrice);
      }

      const targetSlide = document.querySelector(
        `.swiper-slide[data-option-value="${selectedValue}"]`
      );
      if (targetSlide) {
        const slides = Array.from(document.querySelectorAll(".swiper-slide"));
        const targetIndex = slides.indexOf(targetSlide);

        if (targetIndex !== -1) {
          productSlider.slideTo(targetIndex);
        }
      }

      if (addToCartButton && variantId) {
        addToCartButton.dataset.variantId = variantId;
      }

      if (price) {
        const priceElement = document.querySelector(
          ".price-item.price-item--regular"
        );

        if (priceElement) {
          priceElement.textContent = price;
        }
      }

      updateVisibleVariantTabs(variantId);
    });
  });

  function formatMoney(value) {
    const numeric = parseFloat(value.toString().replace(/[^0-9.]/g, ""));
    if (isNaN(numeric)) return "$0.00";
    return `$${numeric.toFixed(2)}`;
  }

  //product tabs

  const tabButtons = document.querySelectorAll(".product-tab__button");
  const tabContents = document.querySelectorAll(".product-tab__content");

  function activateTab(index) {
    tabButtons.forEach((btn, i) => {
      btn.classList.toggle("active", i === index);
      tabContents[i].classList.toggle("active", i === index);
    });
  }

  tabButtons.forEach((btn, index) => {
    btn.addEventListener("click", () => activateTab(index));
  });

  function updateVisibleVariantTabs(variantId) {
    tabContents.forEach((content) => {
      const metafieldRichText = content.querySelector(
        ".metafield-rich_text_field"
      );
      const showMoreBtn = content.querySelector(
        ".product-tab__content-show-more"
      );

      if (!metafieldRichText.classList.contains("clamp")) {
        metafieldRichText.classList.add("clamp");
        if (showMoreBtn) {
          showMoreBtn.textContent = "Show More";
        }
      }
    });

    tabButtons.forEach((btn) => {
      const btnVariantId = btn.dataset.variantId;
      if (btnVariantId) {
        btn.classList.add("hidden-tab");
        btn.classList.remove("active");
      } else {
        btn.classList.remove("active");
      }
    });

    const visibleTabs = [];
    tabButtons.forEach((btn, index) => {
      if (btn.dataset.variantId === variantId || !btn.dataset.variantId) {
        btn.classList.remove("hidden-tab");
        visibleTabs.push({ btn, index });
      }
    });

    tabContents.forEach((content) => content.classList.remove("active"));

    if (visibleTabs.length > 0) {
      const firstVisible = visibleTabs[0];
      firstVisible.btn.classList.add("active");
      tabContents[firstVisible.index].classList.add("active");
    }
  }

  document.querySelectorAll(".product-tab__content").forEach((tab) => {
    const content = tab.querySelector(".metafield-rich_text_field");
    const showMoreBtn = tab.querySelector(".product-tab__content-show-more");

    const clone = content.cloneNode(true);
    clone.style.visibility = "hidden";
    clone.style.position = "absolute";
    clone.style.height = "auto";
    clone.style.webkitLineClamp = "unset";
    clone.style.display = "block";
    document.body.appendChild(clone);

    const lineHeight = parseFloat(getComputedStyle(clone).lineHeight);
    const totalLines = Math.round(clone.offsetHeight / lineHeight);

    document.body.removeChild(clone);

    if (totalLines > 6) {
      content.classList.add("clamp");
      showMoreBtn.style.display = "inline-block";
    } else {
      content.classList.remove("clamp");
      showMoreBtn.style.display = "none";
    }
  });

  document
    .querySelectorAll(".product-tab__content-show-more")
    .forEach((button) => {
      button.addEventListener("click", () => {
        const content = button.previousElementSibling;
        const wasOpen = !content.classList.contains("clamp");
        content.classList.toggle("clamp");

        button.textContent = content.classList.contains("clamp")
          ? "Show More"
          : "Show Less";

        if (wasOpen) {
          const wrapper = document.querySelector(".product-tabs__wrapper");
          const offsetTop =
            wrapper.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: offsetTop - 80,
            behavior: "smooth",
          });
        }
      });
    });

  // Update recharge block selection
  const sellingOptions = document.querySelectorAll(
    'input[type="radio"][name^="selling-option-"]'
  );

  function updateRechargeBlockSelection() {
    sellingOptions.forEach((radio) => {
      const block = radio.closest(".product-recharge-block");
      if (radio.checked) {
        block.classList.add("selected");
      } else {
        block.classList.remove("selected");
      }
    });
  }

  // Handle recharge type change
  sellingOptions.forEach((radio) => {
    radio.addEventListener("change", updateRechargeBlockSelection);
  });

  updateRechargeBlockSelection();

  //color match popup

  const trigger = document.querySelector(".color-match__trigger");
  const popup = document.getElementById("colorMatchPopup");
  const popupContent = document.querySelector(".color-match__popup-content");
  const closeBtn = document.querySelector(".color-match__close");

  if (trigger && popup) {
    trigger.addEventListener("click", function () {
      popup.classList.add("color-match__popup--visible");
    });

    // if (closeBtn) {
    //   closeBtn.addEventListener("click", function () {
    //     popup.classList.remove("color-match__popup--visible");
    //   });
    // }

    window.addEventListener("click", function (e) {
      if (e.target === popupContent) {
        popup.classList.remove("color-match__popup--visible");
      }
    });
  }

  //ingredients modals

  document
    .querySelectorAll('.product-tab__content a[href^="#"]')
    .forEach((link) => {
      link.addEventListener("click", function (e) {
        const modalId = this.getAttribute("href").substring(1);
        const modal = document.querySelector(
          `.ingredients-modal[data-modal="${modalId}"]`
        );
        if (modal) {
          e.preventDefault();
          modal.classList.add("active");
          document.body.style.overflow = "hidden";
        }
      });
    });

  document.querySelectorAll(".modal-close").forEach((btn) => {
    btn.addEventListener("click", function () {
      const modal = this.closest(".ingredients-modal");
      modal.classList.remove("active");
      document.body.style.overflow = "";
    });
  });

  document.querySelectorAll(".modal-overlay").forEach((overlay) => {
    overlay.addEventListener("click", function () {
      const modal = this.closest(".ingredients-modal");
      modal.classList.remove("active");
      document.body.style.overflow = "";
    });
  });
});
